import { getDateSettingDetails, numberOfDaysBetweenDates } from '@bingads-webui-campaign/date-setting';

import { dateSettingsManageAtAdGroupLevelText } from './constants';

export const validateLifetimeBudgetDateRange = (newData, i18n) => {
  const MAX_DATE_RANGE = 365;

  const { StartDate, EndDate } = newData || {};

  if (StartDate && EndDate && numberOfDaysBetweenDates(StartDate, EndDate) > MAX_DATE_RANGE) {
    return i18n.getString(_TL_('The maximum campaign total budget duration is {0} days.')).replace('{0}', MAX_DATE_RANGE);
  }

  return null;
};

export const getAudienceDateSettingsDetails = ({
  i18n, isEdit, dateSettings, isLifetimeBudgetFeatureEnabled,
}) => {
  const {
    UseCampaignLevelDates,
    StartDate,
    EndDate,
  } = dateSettings;

  if (!UseCampaignLevelDates && isEdit) {
    return i18n.getString(dateSettingsManageAtAdGroupLevelText);
  }

  return getDateSettingDetails(i18n, StartDate, EndDate, UseCampaignLevelDates, isLifetimeBudgetFeatureEnabled);
};
